import React from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const workerQuantityData = [];

for (let i = 1; i <= 20; i++) {
  workerQuantityData.push(i);
}

const ThirdSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>
          {t('DATI FORNITORI ESTERNI')}
        </Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Nome azienda fornitore')} name='company_name'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Nr addetti')} name='worker_quantity'>
          <Select disabled={isView} placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {workerQuantityData.map((i) => (
              <Select.Option key={i} value={i}>
                {i}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item
          label={t('Nominativo di contatto')}
          name='company_contract_person'
        >
          <Input disabled={isView} placeholder={'Inserisci testo'} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Telefono di contatto')} name='company_phone'>
          <Input disabled={isView} placeholder={'Inserisci testo'} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(ThirdSection);
